import { render, staticRenderFns } from "./CourseStepperPanel.vue?vue&type=template&id=19c478fc&scoped=true"
import script from "./CourseStepperPanel.vue?vue&type=script&lang=js"
export * from "./CourseStepperPanel.vue?vue&type=script&lang=js"
import style0 from "./CourseStepperPanel.vue?vue&type=style&index=0&id=19c478fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19c478fc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VForm } from 'vuetify/lib/components/VForm';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VDivider,VForm,VLayout})
